import { axiosApiFullyRaw } from "services/api";
import LocalStorage, { getToken } from "helpers/localStorage";
import { LOGOUT_URL } from "helpers/url_helpers";

const LOGOUT_TIMEOUT_MS = 5000;

/**
 * Ends the admin session server-side, then clears local state.
 *
 * GET /api/logout blanks fr_user.auth_token, which is what the backend's
 * JWT validate() checks for admin tokens, so a copied token stops working
 * immediately instead of staying valid for its 30-day lifetime (CWE-613).
 *
 * Local state is always cleared, even if the request fails (offline,
 * timeout, token already invalid), so the user is never stuck logged in.
 */
export const logoutAdmin = async () => {
  try {
    if (getToken()) {
      await axiosApiFullyRaw.get(LOGOUT_URL, {
        timeout: LOGOUT_TIMEOUT_MS,
        skipAuthRedirect: true,
      });
    }
  } catch (error) {
    console.warn("Server logout failed; clearing local session anyway.");
  } finally {
    LocalStorage.clean();
  }
};
